import { render, staticRenderFns } from "./gj-checkbox.vue?vue&type=template&id=e8c46a50&scoped=true&"
import script from "./gj-checkbox.vue?vue&type=script&lang=js&"
export * from "./gj-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./gj-checkbox.vue?vue&type=style&index=0&id=e8c46a50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c46a50",
  null
  
)

export default component.exports